export default __webpack_public_path__ + "locales/fi/Ldap.json?hash=660f0198dc3e1de8ec9558f140e07d66";